module.exports = __webpack_public_path__ + "static/media/IMG_1476.3ab6d9f6.JPG";